import $ from 'jquery';

interface GPBFieldArgs {
	formId: number;
	fieldId: number;
	nonce: string;
}

abstract class GPBField {
	public formId: number;
	public fieldId: number;

	protected nonce: string;

	public $form: JQuery<HTMLFormElement>;
	public $field: JQuery<HTMLElement>;

	constructor(args: GPBFieldArgs) {
		this.formId = args.formId;
		this.fieldId = args.fieldId;
		this.nonce = args.nonce;

		this.$form = $('#gform_' + this.formId);
		this.$field = this.$form.find(`#field_${this.formId}_${this.fieldId}`);
	}

	public abstract init(): void;
}

export default GPBField;
